<template>
  <div ref="profileReportModal" id="profileReportModal" class="modal modal-v modal-v--mobile-fullscreen fade show" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="nav-mobile">
          <div class="nav-mobile__top ">
            <div class="row position-relative">
              <div class="col-3 nav-mobile__top-left">
                <a type="button" class="close" data-dismiss="modal"><i class="demo-icon icon-back"></i></a>
              </div>
              <div class="col-6 nav-mobile__top-center">
                <i class="demo-icon icon-logo-black"></i>
              </div>
            </div>
          </div>
        </div>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>

        <form @submit.prevent="submit" novalidate>
          <div class="modal-body text-center">
            <h2 class="title title--medium mb-3">{{ trans.get('profile:modal.report_profile.report_modal_header') }}</h2>
            <p>{{ responseMessage }}</p>
            <div class="d-flex mx-auto w-100 mb-2" v-for="(violation, index) in violations">
              <div class="radio-item">
                <input :id="'aitem'+index" type="radio" name="myChoice" v-model="form.violation_reason_id" class="form-check-input" :value="violation.id" required>
                <label :for="'aitem'+index"> {{ violation.name }} </label>
              </div>
            </div>
            <!-- Validation message -->
            <p v-if="showValidationReason" class="text-danger">{{ trans.get('profile:modal.report_profile.report_modal_validation') }}</p>

            <div class="form-group">
              <label for="description"> </label>
              <textarea
                id="description"
                v-model="form.description"
                name="description"
                class="form-control"
                minlength="10"
                maxlength="150"
                :required="messageRequired"
              ></textarea>
            </div>
            <div class="checkbox-standard">
              <label>
                <input type="checkbox" id="block" v-model="form.block" name="block">
                <span class="checkbox-standard__box mr-2"></span>
                <span> {{ trans.get('profile:modal.report_profile.block_this_user_checkbox') }} </span>
              </label>
            </div>
            <div v-if="responseErrors.length" class="form-group ">
              <span v-for="responseError in responseErrors" class="invalid-feedback d-block" role="alert"><strong>{{ responseError }}</strong></span>
            </div>
            <div class="d-flex flex-column align-items-center justify-content-start">
              <button type="submit" class="button button__fill mt-3 mb-3">{{ trans.get('profile:modal.report_profile.report_button') }}</button>
              <button type="button" class="button button__link" data-dismiss="modal">{{ trans.get('profile:modal.report_profile.close_button') }}</button>
            </div>

          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportModal',
  props: {},
  data() {
    return {
      show: false,
      showValidationReason: false,
      responseMessage: null,
      form: {
        profile_id: null,
        violation_reason_id: null,
        description: null,
        block: false,
      },
      violations: [],
      responseErrors: [],
    };
  },
  computed: {
    messageRequired: function () {
      let violation = this.violations.find(violation => {
        return violation.id === this.form.violation_reason_id;
      });

      return violation && (violation.has_message === 1);
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.loadViolations();
        this.responseMessage = null;
        this.form.violation_reason_id = null;
        this.form.description = null;
        this.form.block = false;


        $(this.$refs.profileReportModal).modal('show');
      } else {
        $(this.$refs.profileReportModal).modal('hide');
      }
    },
    'form.violation_reason_id'(val) {
      if (val) {
        this.showValidationReason = false;
      }
    }
  },
  methods: {
    close() {
      this.show = false;
      this.$emit('close');
    },
    submit() {
      if (this.form.violation_reason_id) {
        this.responseErrors = [];
        axios
          .post(zRoute('ajax.violations.profile'), this.form)
          .then(response => {
            this.close();
            this.responseMessage = response.data.message;
            this.$eventHub.$emit('ViolationSend');
          })
          .catch(error => {
            if (error.response.status === 422) {
              const data = error.response.data;
              if (data.errors) {
                for (const [name, errors] of Object.entries(data.errors)) {
                  errors.forEach((e) => {
                    this.responseErrors.push(e);
                  });
                }
              }
            }
          });
      } else {
        this.showValidationReason = true;
      }
    },
    loadViolations() {
      if (this.violations.length === 0) {
        axios
          .get(zRoute('ajax.violation_reasons.index', window.globals.violation_reason.type_profile))
          .then(response => {
            this.violations = response.data.data;
          });
      }
    }
  },
  mounted() {
    let vm = this;
    $(this.$refs.profileReportModal).on('hidden.bs.modal', function (e) {
      vm.close();
    });

    this.$eventHub.$on('ReportModalOpen', profileId => {
      vm.form.profile_id = profileId;
      vm.show = true;
    });
  },
};
</script>

<style scoped>

</style>
